/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

const useStyles = makeStyles(() => ({
  textField: {
    maxWidth: '25rem',
    margin: '1rem 0 1.5rem 0',
  },
}));

export default function RemoveUserVerifyDialog({ dialog, toggleDialog, onSubmit, onKeyUp, deleteAvailable }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [value, setValue] = useState('');
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog data-testid="delete-user-verify-dialog" open={dialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <>
          <DialogStatus variant="warning" />
          <Typography component="h3" variant="h3">
            {t('user.management.delete-account.verify.dialog.title')}
          </Typography>
        </>
      </DialogTitle>
      <DialogContent>{t('user.management.delete-account.verify.dialog.description')}</DialogContent>
      <TextField
        className={classes.textField}
        size="small"
        variant="outlined"
        inputProps={{ 'data-testid': 'deleteAccountTextField' }}
        onKeyUp={event => onKeyUp(event.target.value)}
        onChange={handleChange}
        value={value}
      />
      <DialogActions>
        <Button data-testid="cancel-action" color="default" onClick={() => toggleDialog(false)}>
          {t('actions.cancel')}
        </Button>
        <Button data-testid="delete-user-btn" color="primary" onClick={() => onSubmit()} disabled={!deleteAvailable}>
          {t('user.management.delete-account.button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
